"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_VARS = exports.TEMPLATE_VERSION = void 0;
exports.TEMPLATE_VERSION = '1.0.0';
exports.TEMPLATE_VARS = [
    { name: 'orgName', source: 'answer', from: 'orgName', default: '' },
    { name: 'schoolName', source: 'answer', from: 'schoolName', default: '' },
    { name: 'state', source: 'answer', from: 'state', default: '' },
    {
        name: 'duesRequired',
        source: 'answer',
        from: 'duesRequired',
        default: false,
    },
    { name: 'duesAmount', source: 'answer', from: 'duesAmount', default: null },
    { name: 'officers', source: 'computed', from: 'officers', default: '' },
    {
        name: 'officerPresident',
        source: 'answer',
        from: 'officerPresident',
        default: true,
    },
    {
        name: 'officerVicePresident',
        source: 'answer',
        from: 'officerVicePresident',
        default: true,
    },
    {
        name: 'officerTreasurer',
        source: 'answer',
        from: 'officerTreasurer',
        default: true,
    },
    {
        name: 'officerViceTreasurer',
        source: 'answer',
        from: 'officerViceTreasurer',
        default: false,
    },
    {
        name: 'officerSecretary',
        source: 'answer',
        from: 'officerSecretary',
        default: true,
    },
    {
        name: 'officerMemberAtLarge',
        source: 'answer',
        from: 'officerMemberAtLarge',
        default: false,
    },
    {
        name: 'officerCommunications',
        source: 'answer',
        from: 'officerCommunications',
        default: true,
    },
    {
        name: 'officerVolunteerCoordinator',
        source: 'answer',
        from: 'officerVolunteerCoordinator',
        default: true,
    },
    {
        name: 'electionMonth',
        source: 'answer',
        from: 'electionMonth',
        default: 'May',
    },
    { name: 'termLength', source: 'answer', from: 'termLength', default: 1 },
    { name: 'termLimit', source: 'answer', from: 'termLimit', default: 2 },
    {
        name: 'meetingFrequency',
        source: 'answer',
        from: 'meetingFrequency',
        default: 'monthly',
    },
    {
        name: 'quorumExecMode',
        source: 'answer',
        from: 'quorumExecMode',
        default: 'half the number of board members plus one',
    },
    {
        name: 'quorumExecBoard',
        source: 'computed',
        from: 'quorumExecBoard',
        default: 3,
    },
    {
        name: 'quorumExecSummary',
        source: 'computed',
        from: 'quorumExecSummary',
        default: '',
    },
    {
        name: 'fiscalYearStartMonth',
        source: 'answer',
        from: 'fiscalYearStartMonth',
        default: 'July',
    },
    {
        name: 'fiscalYearStartDay',
        source: 'answer',
        from: 'fiscalYearStartDay',
        default: 1,
    },
    {
        name: 'fiscalYearEndMonth',
        source: 'answer',
        from: 'fiscalYearEndMonth',
        default: 'June',
    },
    {
        name: 'fiscalYearEndDay',
        source: 'answer',
        from: 'fiscalYearEndDay',
        default: 30,
    },
    {
        name: 'routineSpendingLimit',
        source: 'answer',
        from: 'routineSpendingLimit',
        default: 200,
    },
    {
        name: 'nonBudgetedBoardLimit',
        source: 'answer',
        from: 'nonBudgetedBoardLimit',
        default: 500,
    },
    {
        name: 'checkPolicy',
        source: 'answer',
        from: 'checkPolicy',
        default: 'Routine spending is capped at the board-approved limit and requires board approval for larger expenditures.',
    },
    {
        name: 'checkSignersMode',
        source: 'answer',
        from: 'checkSignersMode',
        default: 'twoSigners',
    },
    {
        name: 'checkSignersSummary',
        source: 'computed',
        from: 'checkSignersSummary',
        default: '',
    },
    {
        name: 'conflictAppliesTo',
        source: 'answer',
        from: 'conflictAppliesTo',
        default: 'Board, officers, and key volunteers',
    },
    {
        name: 'conflictRecordkeeping',
        source: 'answer',
        from: 'conflictRecordkeeping',
        default: 'Standard (keep a simple log of disclosures)',
    },
    {
        name: 'conflictApplicabilitySentence',
        source: 'computed',
        from: 'conflictApplicabilitySentence',
        default: '',
    },
    {
        name: 'conflictRecordkeepingSummary',
        source: 'computed',
        from: 'conflictRecordkeepingSummary',
        default: '',
    },
    {
        name: 'amendmentNoticeDays',
        source: 'answer',
        from: 'amendmentNoticeDays',
        default: 14,
    },
];
